import { Badge } from "@/components/ui/badge";
import { CredenzaBody, CredenzaDescription, CredenzaHeader, CredenzaTitle } from "@/components/ui/credenza";
import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/locales/client";
import { Coins, Landmark } from "lucide-react";

export function PaymentMethod({
    onChoose,
    currency,
}: { onChoose: (method: "bank" | "crypto") => void; currency: "EUR" | "USD" }) {
    const t = useScopedI18n("paymentDialogs.common.paymentMethod");

    return (
        <>
            <CredenzaHeader>
                <CredenzaTitle>{t("title")}</CredenzaTitle>
                <CredenzaDescription>{t("description")}</CredenzaDescription>
            </CredenzaHeader>
            <CredenzaBody className="mb-4 flex gap-3">
                <Card
                    icon={<Landmark />}
                    title={t("methods.bank.title")}
                    description={t("methods.bank.description")}
                    badge={t("methods.bank.badge")}
                    onClick={() => onChoose("bank")}
                />
                <Card
                    icon={<Coins />}
                    title={currency === "USD" ? t("methods.crypto.titleUSD") : t("methods.crypto.titleEUR")}
                    description={t("methods.crypto.description")}
                    badge={t("methods.crypto.badge")}
                    onClick={() => onChoose("crypto")}
                />
            </CredenzaBody>
        </>
    );
}

function Card({
    icon,
    title,
    description,
    badge,
    onClick,
}: {
    icon: React.ReactNode;
    title: string;
    description: string;
    badge: string;
    onClick?: () => void;
}) {
    return (
        <button
            type="button"
            autoFocus={false}
            className={cn(
                "group mx-1 flex basis-1/2 flex-col items-center gap-4 rounded-md border bg-card p-4 text-left text-card-foreground shadow-xs hover:bg-muted disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground md:flex-row",
                "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
            )}
            onClick={onClick}
        >
            <div className="w-8">{icon}</div>

            <div className="flex flex-col items-center md:items-start">
                <div className="text-center font-semibold text-sm md:text-start">{title}</div>
                <div className="text-center text-muted-foreground text-sm md:text-start">{description}</div>
                <Badge variant="secondary" className="mt-2 group-hover:bg-popover">
                    {badge}
                </Badge>
            </div>
        </button>
    );
}
